import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@/sass/variables.scss'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#ed2f59',
        secondary: '#32335b',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    },
    icons: {
      iconfont: 'mdi'
    }
  }
})
